export default {"src":"/_next/static/media/credit_tracker.6bd84a29.svg","height":100,"width":104,"blurWidth":0,"blurHeight":0};